import { OnBoardingCard } from 'components/OnBoardingCard'
import { useNavigate } from 'react-router'
import { OnBoardingContainer } from 'components/ui/OnBoardingContainer'
import { ResetPasswordModal } from 'components/modals/ResetPasswordModal'
import { useTranslation } from 'react-i18next'

export const ResetPasswordPage = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const onClickBackToLogin = () => {
    navigate('/login')
  }

  return (
    <OnBoardingContainer>
      <OnBoardingCard>
        <ResetPasswordModal
          onSuccess={() => navigate('/login')}
          backToLogin={
            <div className={'tw-text-sm tw-underline tw-cursor-pointer tw-mt-2'} onClick={onClickBackToLogin}>
              {t('backToLogin')}
            </div>
          }
        />
      </OnBoardingCard>
    </OnBoardingContainer>
  )
}
